<template>

    <!-- FOOTER -->
    <footer class="noselect" :class="it" :style="{ borderTopColor: cssPropColor('$color-border') }">

        <branding
            :logo="company.logo"
            :altText="company.company_name"
            :link="company.url"
            linkTarget="_blank"
            v-if="loaded"></branding>

        <transition
                name="company-nav-transition"
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown">

            <!-- NAV - COMPANY -->
            <nav class="company" v-if="hasEntered" :style="{ borderRightColor: cssPropColor('$color-border'), borderLeftColor: cssPropColor('$color-border') }">
                <ul>
                    <!-- ABOUT -->
                    <li v-if="(aboutPosition === 'footer')" :style="{ borderRightColor: cssPropColor('$color-border') }">
                        <a @click="togglePanel('panel-content-about', 'about-us', $event)" :class="{ active: (activePanel === 'panel-content-about') }" title="About">
                            <span class="icon"><i class="icon-MBR_information" aria-hidden="true"></i></span>
                            <span class="label">About</span>
                        </a>
                    </li>
                    <!-- COVERAGES -->
                    <li v-if="hasCoverages">
                        <a @click="togglePanel('panel-content-coverages', 'additional-coverages', $event)" :class="{ active: (activePanel === 'panel-content-coverages') }" :style="{ borderRightColor: cssPropColor('$color-border') }" title="Additional Coverages">
                            <span class="icon"><i class="icon-MBR_additional" aria-hidden="true"></i></span>
                            <span class="label" v-html="addCoverageLabel"></span>
                        </a>
                    </li>
                    <!-- CONTACT -->
                    <li>
                        <a @click="togglePanel('panel-content-contact', 'contact-us', $event)" :class="{ active: (activePanel === 'panel-content-contact') }" :style="{ borderRightColor: cssPropColor('$color-border') }" title="Contact Us">
                            <span class="icon"><i class="icon-MBR_contact" aria-hidden="true"></i></span>
                            <span class="label" v-html="contact.form_label"></span>
                        </a>
                    </li>
                </ul>
            </nav>
            <!-- END NAV - COMPANY -->

        </transition>


        <transition
                name="legal-nav-transition"
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown">

            <!-- NAV - LEGAL -->
            <nav class="legal" v-if="hasEntered">
                <ul>
                    <!-- PRIVACY -->
                    <li>
                        <a @click="togglePanel('panel-content-privacy', 'privacy-policy', $event)" :class="{ active: (activePanel === 'panel-content-privacy') }" title="Privacy Policy">
                            <span class="label">Privacy Policy</span>
                        </a>
                    </li>
                    <!-- TERMS -->
                    <li>
                        <a @click="togglePanel('panel-content-terms', 'terms-of-service', $event)" :class="{ active: (activePanel === 'panel-content-terms') }" title="Terms and Conditions">
                            <span class="label">Terms and Conditions</span>
                        </a>
                    </li>
                </ul>
            </nav>
            <!-- END NAV - LEGAL -->

        </transition>

    </footer>
    <!-- END FOOTER -->

</template>


<script>

    import Branding from "./Branding.vue";

    let vm = {};

    export default {

        name: 'app-footer',

        components: {
            Branding
        },

        data() {
            return {
                it: 'horizontal'
            }
        },

        computed: {

            loaded() {
                return this.$dataStore.getters.getLoadedState;
            },

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            company() {
                return this.$dataStore.getters.getCompany;
            },

            aboutPosition() {
                return this.$dataStore.getters.getAboutPosition;
            },

            activePanel() {
                return this.$dataStore.getters.getActivePanel;
            },

            hasCoverages() {
                let _coverages = this.$dataStore.getters.getCoverages;
                return (_coverages.length > 0);
            },

            contact() {
                return this.$dataStore.getters.getCompanyContactData;
            },

            addCoverageLabel() {
                return this.$dataStore.getters.getAdditionalCoveragesLabel;
            },

            powerSurgeState() {
                return this.$dataStore.getters.getPowerSurgeState;
            },

            powerSurgeOverlayState() {
                return  this.$dataStore.getters.getPowerSurgeOverlayState;
            }

        },

        created() {
            //console.info('%cAppFooter::created', 'color:dodgerblue;');
            vm = this;

            this.$eventBus.$on('footer:image', (it) => vm.setIt(it));
        },

        mounted() {
            //console.info('%cAppFooter::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             */
            togglePanel(type, slug, evt) {

                if (vm.powerSurgeState && !vm.powerSurgeOverlayState) { return false; }

                if (vm.powerSurgeState) {
                    this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                    this.$eventBus.$emit('power-surge:end');
                }

                switch(type) {
                    case 'panel-content-about':
                        vm.trackEvent('About Button', 'Footer');
                        break;
                    case 'panel-content-coverages':
                        vm.trackEvent(vm.addCoverageLabel + ' Button');
                        break;
                    case 'panel-content-contact':
                        vm.trackEvent(vm.contact.form_label + ' Button');
                        break;
                    case 'panel-content-privacy':
                        vm.trackEvent('Legal Link', 'Privacy Policy');
                        break;
                    case 'panel-content-terms':
                        vm.trackEvent('Legal Link', 'Terms and Conditions');
                        break;
                }

                //console.info('%ctogglePanel', 'color:orange;');
                evt.stopPropagation();
                this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug });
            },

            setIt(it) {
                vm.it = it;
            },

            trackEvent(action, label) {
                gtag('event', action, {
                    'event_category': 'MBRe: Residential',
                    'event_label': label || ''
                });
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        }

    }

</script>


<style lang="scss" scoped="">

    @import '../assets/styles/helpers/variables';

    footer {
        background-color: $white-100;
        height: 95px;
        padding: 0 0 0 0;
        border-top: 1px solid rgba(74,74,74, 0.25);
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        flex: none;
        z-index: 5;
        transition: all 0.3s $easeInOutQuad;
        animation-duration: 0.3s;
        animation-delay: 0.4s;

        &.horizontal {

        }

        &.vertical {
            height: 150px;
        }
    }

    nav {

        & ul {
            list-style-type: none;
            height: 100%;
            margin: 0 0 0 0;
            padding: 0 0 0 0;
            display: flex;
            flex-flow: row nowrap;

            & > li {
                margin: 0 0 0 0;

                & a {
                    font-family: $font-univers-cond;
                    line-height: 1;
                    letter-spacing: 0.84px;
                    text-transform: uppercase;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        &.company {
            border-right: 1px solid rgba(74,74,74, 0.25);
            border-left: 1px solid rgba(74,74,74, 0.25);
            height: 100%;
            flex: 0 0 auto;
            animation-duration: 0.3s;
            animation-delay: 0.2s;

            & li {
                height: 100%;
                border-right: 1px solid rgba(74,74,74, 0.25);

                &:last-child {
                    border-right: none !important;
                }
            }

            & a {
                color: var(--color-base-text);
                font-size: 0.875rem;
                font-weight: normal;
                text-decoration: none;
                height: 100%;
                padding: 0 30px;
                position: relative;

                &::before {
                    content: '';
                    background-color: var(--color-primary);
                    width: 100%;
                    height: 2px;
                    display: block;
                    position: absolute;
                    top: -1px;
                    left: 0;
                    transform: scaleY(0);
                    transition: all 0.3s $easeInOutQuad;
                }

                &:hover {
                    color: var(--color-primary);

                    &::before {
                        transform: scaleY(1);
                        transition: all 0.3s $easeInOutQuad;
                    }
                }

                &.active {
                    color: var(--color-primary);

                    &::before {
                        height: 2px;
                        transform: scaleY(1);
                        transition: all 0.3s $easeInOutQuad;
                    }
                }

                & .icon {
                    font-size: 23px;
                    margin: 0 8px 0 0;

                    & > i {
                        display: block;
                    }
                }
            }
        }

        &.legal {
            height: 100%;
            padding: 0 30px 0 0;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            flex: 1 0 auto;

            & li {
                height: 100%;
                padding: 0 0 0 15px;
            }

            & a {
                font-family: $font-univers-std;
                font-size: 0.625rem;
                letter-spacing: initial;
                color: var(--color-base-text);
                text-transform: none;
                height: 100%;

                &:hover {
                    color: var(--color-primary);
                }

                &.active {
                    color: var(--color-primary);
                    text-decoration: none;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// AppFooter.vue?0f1187ac